import Sidebar from "../components/Sidebar";
import blogPosts from "../BlogPosts";

export default function Home() {
    return (
        <div className="home">
            <div className="home-column">
                <h2>Welcome to ChessAssess, a website by Johnathan Browning</h2>
                <iframe
                    src={`https://www.youtube.com/embed/${"DHmwbUUOVG4"}`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
                <p className='caption'>{"GMHikaru watching my Candidates 2024 video"}</p>
            </div>
            <Sidebar blogPosts={blogPosts} />
        </div>
    );
}